import type { FC } from 'react'
import {
	AdvancedImage,
	responsive,
	lazyload,
	placeholder,
} from '@cloudinary/react'
import { fill } from '@cloudinary/url-gen/actions/resize'

import { Cloudinary } from '@cloudinary/url-gen'

// TODO: Add lazyload prop
interface Props {
	publicId: string
	type: string | null
}

const RecipeImage: FC<Props> = ({ publicId, type }) => {
	const cldImage = new Cloudinary({
		cloud: {
			cloudName: 'sheadscott',
		},
	})

	const img = cldImage.image(publicId)

	if (type === 'card') {
		img
			.resize(fill().aspectRatio('16:9'))
			.format('auto')
			.addTransformation('dpr_2.0')
	} else {
		img.format('auto').addTransformation('dpr_2.0').quality('auto')
	}

	// console.log('TYPE :>> ', type)

	return (
		// <div className="absolute right-0 top-0 flex h-full items-center justify-center">
		// { type === 'card' ? (<div className="w-full">) : (<div className="w-full  border border-secondary p-[1px]">) }
		<div
			className={
				type === 'card'
					? 'w-full'
					: 'w-full max-w-lg border border-secondary p-[1px]'
			}
		>
			<AdvancedImage
				cldImg={img}
				style={{ maxWidth: '100%' }}
				// plugins={[lazyload()]}
				// plugins={[lazyload(), responsive([1000, 1200, 1400, 1600])]}
				plugins={[lazyload(), responsive(200), placeholder()]}
				// plugins={[lazyload(), responsive(200), placeholder()]}
				className="object-cover"
				width="600px"
				height="400px"
			/>
		</div>
	)
}

export default RecipeImage
